"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Divider = _interopRequireDefault(require("../Divider"));

var _AppSidebarMenuItem = require("../AppSidebarMenuItem");

var _AppSidebarMenuItemIcon = require("../AppSidebarMenuItemIcon");

var _AppSidebarMenuItemContent = require("../AppSidebarMenuItemContent");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 340px;\n  height: 100vh;\n  background-color: #050505;\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);\n  transition: width 0.3s;\n  font-family: 'Raleway', sans-serif;\n  font-size: 14px;\n  color: #686868;\n\n  &.app-sidebar--collapsed {\n    width: 90px;\n  }\n\n  ", " {\n    color: #222222;\n    border-bottom-color: #222222;\n    width: 100%;\n    margin: 12px 0px;\n  }\n\n  &.app-sidebar--collapsed ", " {\n    width: 100%;\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n\n  &.app-sidebar--collapsed ", " {\n    width: 100%;\n    text-align: center;\n    box-sizing: border-box;\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n\n  &.app-sidebar--collapsed ", " {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n\n  &.app-sidebar--collapsed ", " {\n    display: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Sidebar = _styledComponents["default"].div(_templateObject(), _Divider["default"], _AppSidebarMenuItem.StyledAppSidebarMenuItem_Content, _AppSidebarMenuItem.StyledAppSidebarMenuItem, _AppSidebarMenuItemIcon.StyledAppSidebarMenuItemIcon, _AppSidebarMenuItemContent.StyledAppSidebarMenuItemContent);

function AppSidebar(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/_react["default"].createElement(Sidebar, _extends({}, props, {
    className: (0, _clsx["default"])(props.className, {
      'app-sidebar--collapsed': !props.open
    })
  }), children);
}

var _default = AppSidebar;
exports["default"] = _default;